<template>
  <div class="alert mb-1 mt-1" :class="`alert-${message.type}`">
    {{ message.message }}
    <button type="button" class="close" @click="handleCLose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "Notification",
  props: ["message", "idx"],
  data() {
    return {
      timeout: undefined
    }
  },
  methods: {
    ...mapActions(["removeFlashMessage"]),
    handleCLose() {
      clearTimeout(this.timeout);
      this.removeFlashMessage(this.idx);
    }
  },
  created() {
    this.timeout = setTimeout(() => {
      this.removeFlashMessage(this.idx)
    }, 15000);
  }
}
</script>

<style scoped>
</style>